import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Background from '@/components/Background.vue';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import VariableLogo from '@/components/VariableLogo.vue';
import MenuService from "../services/MenuService";
import CardLayout from "@/layouts/CardLayout.vue";
import Modal from "@/components/Modal.vue";
import AjaxButton from "@/components/AjaxButton.vue";
import LanguageSelector from '@/components/LanguageSelector.vue';
import { MainView, TypeOrder } from '@/store/state';
import { TypeView } from "@/models/Menu";
import { localizedDeliveryDescription } from "@/utils/LocalizationsUtils";
import { isOpen, getDayOfWeek } from "@/utils/ScheduleUtils";
import HomeButton from "@/components/HomeButton.vue";
let InfoRestaurant = class InfoRestaurant extends Vue {
    constructor() {
        super(...arguments);
        this.activeBtn = true;
        this.loading = true;
        this.foundRestaurant = false;
        this.nameRestaurant = '';
        this.address = '';
        this.delivery = false;
        this.imageDeliveryURL = '';
        this.phone = '';
        this.openRestaurant = false;
        this.schedule = undefined;
        this.scheduleInitDay = '';
        this.scheduleEndDay = '';
        this.shipping = false;
        this.collect = false;
        this.facebook = '';
        this.instagram = '';
        this.url = '';
        this.ajaxError = false;
        this.modalForm = false;
        this.active = true;
        this.languajeSelector = false;
        this.descriptionDelivery = "";
        this.domingoClose = false;
        this.lunesClose = false;
        this.martesClose = false;
        this.miercolesClose = false;
        this.juevesClose = false;
        this.viernesClose = false;
        this.sabadoClose = false;
        this.viewByQr = false;
    }
    async created() {
        this.viewByQr = false;
        const restaurantId = this.$route.params.restaurantId;
        const menuId = this.$route.params.menuId;
        await this.$store.dispatch('getRestaurant', restaurantId);
        if (!this.$store.state.restaurant) {
            await this.notFound();
            return;
        }
        await this.$store.dispatch('getMenu', menuId);
        if (!this.$store.state.menu) {
            await this.notFound();
            return;
        }
        await this.$store.dispatch('getDeliveryMenu', this.$store.state.menu.id);
        const result = MenuService.getSocialNetworkFromMenu(this.$store.state.menu.id);
        result.then(res => {
            if (res != null) {
                if (res.facebook != null)
                    this.facebook = res.facebook;
                if (res.instagram != null)
                    this.instagram = res.instagram;
            }
        });
        await this.$store.dispatch('setNewOrder');
        await this.showInfoRestaurantDelivery();
        if (this.$route.query.origin == 'qr') {
            this.viewByQr = true;
            await MenuService.addView(this.$store.state.menu.id, TypeView.QR);
        }
        if (this.$store.state.mainView == MainView.DIRECTORY && this.delivery) {
            this.$router.push('/menu');
            await MenuService.addView(this.$store.state.menu.id, TypeView.SHIPPING);
        }
    }
    async gotoMenu() {
        await this.$store.dispatch('setTypeOrder', TypeOrder.LOCAL);
        await this.$router.push('/menu');
    }
    async notFound() {
        this.foundRestaurant = false;
        this.loading = false;
    }
    async showInfoRestaurantDelivery() {
        const menu = this.$store.state.menu;
        const delivery = this.$store.state.deliveryMenu;
        if (menu) {
            this.foundRestaurant = true;
            this.nameRestaurant = menu.name;
            this.active = menu.active;
            const localizations = menu.localizations;
            this.loading = true;
            this.openRestaurant = await isOpen(menu.id);
            this.loading = false;
            if (localizations && localizations.length == 1 && this.active) {
                this.setLocalization(localizations[0]);
            }
            else {
                this.languajeSelector = true;
                const local = localizations.find(local => local.language == 'spanish');
                if (local)
                    this.setLocalization(local);
            }
        }
        if (delivery) {
            const now = new Date();
            const dayOfWeek = getDayOfWeek(now.getDay());
            this.delivery = delivery.active;
            this.address = delivery.address;
            this.descriptionDelivery = localizedDeliveryDescription(delivery);
            this.imageDeliveryURL = delivery.imageDeliveryURL;
            this.phone = delivery.phones?.localPhone?.phone || '';
            if (delivery.schedule) {
                this.schedule = delivery.schedule;
                this.getOpenDays(this.schedule);
                this.scheduleInitDay = delivery.schedule[dayOfWeek].initHour.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                this.scheduleEndDay = delivery.schedule[dayOfWeek].endHour.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            }
            this.shipping = delivery.shipping;
            this.collect = delivery.collect;
        }
    }
    setLocalization(localization) {
        this.$store.dispatch('changeCurrency', localization.currency);
        this.$store.dispatch('changeLanguage', localization.language);
        this.$emit('select');
        this.languageSelected();
    }
    languageSelected() {
        const lang = this.$store.state.language;
        this.$store.state.deliveryMenu.descriptionDelivery.forEach(async (docDescriptionDelivery) => {
            if (docDescriptionDelivery.language == lang.toUpperCase() || docDescriptionDelivery.language == lang) {
                this.descriptionDelivery = docDescriptionDelivery.text;
            }
        });
    }
    async addViewsShipping() {
        if (!this.viewByQr) {
            await MenuService.addView(this.$store.state.menu.id, TypeView.SHIPPING);
        }
        await this.$store.dispatch('setTypeOrder', TypeOrder.DELIVERY);
        await this.$router.push('/menu');
    }
    async addViewsCollect() {
        if (!this.viewByQr) {
            await MenuService.addView(this.$store.state.menu.id, TypeView.COLLECT);
        }
        await this.$store.dispatch('setTypeOrder', TypeOrder.COLLECT);
        await this.$router.push('/menu');
    }
    get style() {
        return `background-image: url('${this.imageDeliveryURL}')`;
    }
    hideForm() {
        this.modalForm = true;
        const active = this.$store.state.deliveryMenu.shipping;
        if (active === false || !this.openRestaurant) {
            return this.activeBtn = false;
        }
    }
    getOpenDays(schedule) {
        this.domingoClose = schedule.DOMINGO.open;
        this.lunesClose = schedule.LUNES.open;
        this.martesClose = schedule.MARTES.open;
        this.miercolesClose = schedule.MIERCOLES.open;
        this.juevesClose = schedule.JUEVES.open;
        this.viernesClose = schedule.VIERNES.open;
        this.sabadoClose = schedule.SABADO.open;
    }
};
InfoRestaurant = __decorate([
    Component({
        components: {
            Background,
            VariableLogo,
            SpinnerHolder,
            CardLayout,
            Modal,
            AjaxButton,
            LanguageSelector,
            HomeButton
        }
    })
], InfoRestaurant);
export default InfoRestaurant;
